import type { FlowNode } from '../types/flow-types';

/** Device Check nodes intentionally expose only their matching (true) path. */
export function isDeviceCheckSingleOutput(node: Pick<FlowNode, 'data'>): boolean {
	return String((node.data as any)?.paletteKey || '') === 'deviceCheck';
}
